import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Compass, ArrowLeft, Mail, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { API } from "@/App";
import { toast } from "sonner";

const ForgotPasswordPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const res = await fetch(`${API}/auth/forgot-password`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, origin_url: window.location.origin }),
      });
      if (res.ok) { setSent(true); toast.success("Check your email"); }
      else toast.error("Something went wrong");
    } catch (e) { toast.error("Something went wrong"); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-dark flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <Link to="/login" className="inline-flex items-center gap-2 text-white/40 hover:text-white mb-6 text-sm"><ArrowLeft className="w-4 h-4" />Back to sign in</Link>
        <div className="bg-dark-paper border border-white/10 rounded-2xl p-8">
          <div className="flex items-center gap-2 mb-6">
            <div className="w-8 h-8 rounded-lg bg-purple-700 flex items-center justify-center"><Compass className="w-4 h-4 text-white" /></div>
            <span className="font-inter font-bold text-lg">promptviser</span>
          </div>
          <h1 className="font-inter font-bold text-2xl mb-2">Forgot password?</h1>
          <p className="text-white/50 text-sm mb-6">Enter your email and we'll send you a reset link.</p>

          {sent ? (
            <div className="text-center py-6" data-testid="forgot-password-sent">
              <Mail className="w-10 h-10 text-neon mx-auto mb-3" />
              <p className="text-white/70 text-sm mb-4">If an account exists for <b>{email}</b>, you'll receive a reset link within a minute.</p>
              <Link to="/login"><Button variant="outline" className="border-white/20 text-sm">Back to sign in</Button></Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <Label className="text-xs">Email address</Label>
                <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="bg-dark-subtle border-white/10 text-sm" placeholder="you@example.com" data-testid="forgot-email-input" />
              </div>
              <Button type="submit" disabled={loading} className="w-full bg-purple-700 text-white hover:bg-purple-600" data-testid="forgot-submit">
                {loading ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" />Sending…</> : "Send reset link"}
              </Button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
